import {Injectable} from '@angular/core';
import {PortalService} from '../../services/portal.service';
import {ThermostatcheckAnfrage} from "../anfrage/thermostatcheck.anfrage";
import {ThermostatcheckBackendService} from "./backend.service";
import {Router} from "@angular/router";
import {RequestService} from "../../services/request.service";
import {EmbedService} from "../../services/embed.service";
import {RequestAnfrage} from "../../model/request.anfrage";

/**
 * global advisordata that can be injected by the backend
 * @var object
 */
declare let advisorObjectData;

/**
 * Service for saving the request data locally in the browser to have it on all steps.
 */
@Injectable({
  providedIn: 'root'
})
export class ThermostatcheckRequestService extends RequestService{

  /**
   * @inheritdoc
   */
  requestObjectName = 'tec-anfrage';

  /**
   * constructor.
   */
  constructor(public backendService: ThermostatcheckBackendService, private router: Router,
              protected portalService: PortalService, protected embedService: EmbedService) {
    super(backendService, portalService, embedService);

    try {
      if (typeof advisorObjectData === "object" && typeof localStorage === "object") {
        // save injected data
        localStorage.setItem(this.requestObjectName, JSON.stringify(advisorObjectData));

        // if we preset the data, redirect to result step
        this.router.navigate([this.portalService.currentPortalId + '/thermostatcheck/ergebnis/analyse']);
      }
    } catch (e) {

    }

    this.loadDataFromLocalStorage();
  }

  /**
   * @inheritdoc
   */
  getNewAnfrage(): RequestAnfrage {
    return new ThermostatcheckAnfrage();
  }

  /**
   * @inheritdoc
   */
  getAnfrage(): ThermostatcheckAnfrage {
    return super.getAnfrage() as ThermostatcheckAnfrage;
  }

}
